export default "__VITE_ASSET__D8nqpAY5__"